/**
 * Shared SEO constants. CommonJS on purpose (see publicRoutes.js) so build-time Node scripts
 * (scripts/prerender.js, scripts/generate-sitemap.js) can require() it directly alongside React
 * view usage via `import`.
 */
module.exports = {
  SITE_URL: 'https://roster-rx.com',
  DEFAULT_OG_IMAGE: 'https://roster-rx.com/logo512.png',
};